import { Stack } from '@mui/material';
import {
  type Control,
  type FieldErrors,
  type FieldArrayWithId,
} from 'react-hook-form';

import {
  type ExperimentStatusSchema,
  type GroupExperimentSchema,
} from '@/zod_schemas';
import SampleForm2 from '../SampleForm2';

interface ISamplesContainer2Props {
  control: Control<GroupExperimentSchema>;
  experimentIndex: number;
  experimentStatus?: ExperimentStatusSchema;
  errors: FieldErrors<GroupExperimentSchema>;
  fields: FieldArrayWithId<GroupExperimentSchema, 'samples'>[];
}

const SamplesContainer2 = ({
  control,
  errors,
  experimentIndex,
  experimentStatus,
  fields,
}: ISamplesContainer2Props) =>
  fields.length > 0 && (
    <Stack spacing={1}>
      {fields.map(({ id }, index) => (
        <SampleForm2
          index={index}
          experimentIndex={experimentIndex}
          experimentStatus={experimentStatus}
          key={id}
          errors={errors}
          control={control}
        />
      ))}
    </Stack>
  );

export default SamplesContainer2;
